export enum SpacingToken {
  none = '0rem',
  nano = '0.2rem',
  xxmc = '0.4rem',
  xmc = '0.8rem',
  micro = '1.2rem',
  xxxs = '1.6rem',
  xxs = '2.0rem',
  xs = '2.4rem',
  sm = '3.2rem',
  md = '4.0rem',
  lg = '4.8rem',
  xl = '5.6rem',
  xxl = '6.4rem',
  xxxl = '8.0rem',
  hg = '9.6rem',
  xh = '12.8rem',
  xxh = '16rem',
  giant = '19.2rem',
  display = '25.6rem',
}

export default SpacingToken

export type TSpacing =
  | 'none'
  | 'nano'
  | 'xxmc'
  | 'xmc'
  | 'micro'
  | 'xxxs'
  | 'xxs'
  | 'xs'
  | 'sm'
  | 'md'
  | 'lg'
  | 'xl'
  | 'xxl'
  | 'xxxl'
  | 'hg'
  | 'xh'
  | 'xxh'
  | 'giant'
  | 'display'
